import qs from 'qs';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import * as Auth from 'src/libs/auth';
import { HOME_PAGE_ROUTE } from '../home/page';

export const AUTH_CALLBACK_ROUTE = '/auth/callback';

interface IProps {
  getRedirectUrl: () => string | null;
}

interface IState {
  hasCode: boolean;
  redirectUrl: string;
}

class AuthCallbackPage extends React.Component<IProps, IState> {
  public state = {
    hasCode: false,
    redirectUrl: HOME_PAGE_ROUTE,
  };

  public async componentDidMount() {
    const { code } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    await Auth.requestAccessToken(code);

    const redirectUrl = this.props.getRedirectUrl();

    if (redirectUrl === null) {
      this.setState(state => ({ ...state, hasCode: true }));
    } else {
      this.setState(state => ({ ...state, hasCode: true, redirectUrl }));
    }
  }

  public render() {
    if (this.state.hasCode) {
      return <Redirect to={this.state.redirectUrl} />;
    }

    return <div>processing response</div>;
  }
}

export default AuthCallbackPage;
